import { SetSimulatedPlayerStatus } from '../../gameClient/clientCommands/setSimulatedPlayerStatus';

type UpdateSimulateStatusParams = {
    isOnline: boolean
}

export class UpdateSimulatedPlayerStatus {
    public handle(params: UpdateSimulateStatusParams): void {
        if (params.isOnline) {
            return SetSimulatedPlayerStatus.getInstance().setOnline();
        }
        return SetSimulatedPlayerStatus.getInstance().setOffline();
    }
}
